import React from 'react';

const Unauthorized = (props) => (
      <div>
        <h2>Access Denied</h2><br/>
        <div className="caption">
            You do not appear to be affiliated with rules engine application. If this is in error, please contact the <a href="mailto:access@osu.edu">Access Management Team</a>&nbsp;at access@osu.edu with a brief description of the information you need to access for rules engine application.
        </div>
      </div>
);

export default Unauthorized;


// WEBPACK FOOTER //
// ./src/components/Unauthorized/Unauthorized.js